import { combineEpics } from 'redux-observable'
import fetchFilteredPackagesEpic from './fetchFilteredPackages'
import fetchFiltersEpic from './fetchFilters'
import initFiltersEpic from './initFilters'
import initFiltersWithContextSelectionEpic from './initFiltersWithContextSelection'
import selectFiltersEpic from './selectFilters'
import updateFiltersQueryEpic from './updateFiltersQuery'

export default combineEpics(
  fetchFilteredPackagesEpic,
  fetchFiltersEpic,
  initFiltersEpic,
  initFiltersWithContextSelectionEpic,
  selectFiltersEpic,
  updateFiltersQueryEpic
)
